module.exports = __webpack_public_path__ + "img/zaun1.dd2cc925.png";